const focusableSelector = `
  a[href]:not([tabindex='-1']), 
  area[href]:not([tabindex='-1']), 
  input:not([type='hidden']):not([disabled]):not([aria-hidden='true']):not([tabindex='-1']), 
  select:not([disabled]):not([aria-hidden='true']):not([tabindex='-1']), 
  textarea:not([disabled]):not([aria-hidden='true']):not([tabindex='-1']), 
  button:not([disabled]):not([aria-hidden='true']):not([tabindex='-1']), 
  iframe:not([tabindex='-1']), 
  object:not([tabindex='-1']), 
  embed:not([tabindex='-1']), 
  [contenteditable]:not([tabindex='-1']), 
  [tabindex]:not([tabindex='-1'])`;

let returnFocusTo = null;

$(document).ready(function () {
    $("html").attr("data-page-url", `${window.location.pathname}`);
    // $("body").append('<div class="sr-only live-status-region" role="status"></div>');

    $('form[aria-expanded]').each((i, form) => {
        $(form).removeAttr('aria-expanded');
    });

    $([
        '[data-page-url="/pages/mens-bike-pant-size-guide"]',
        '[data-page-url="/pages/mens-jeans-fit-guide"]',
        '[data-page-url="/pages/mens-jort-size-chart"]',
        '[data-page-url="/pages/mens-overalls-fit-1"]',
        '[data-page-url="/pages/unisex-trousers-fit-guide"]',
        '[data-page-url="/pages/womens-bike-pant-sizing"]',
        '[data-page-url="/pages/womens-jeans-fit-guide"]',
        '[data-page-url="/pages/womens-jort-size-chart"]',
        '[data-page-url="/pages/womens-overalls-size-chart"]',
    ]).each((i, page) => {
        const title = $(page).find('.main-page-title');

        $(page).find('table').each((i, table) => {
            $(table).attr("aria-label", `${title.text().trim()}`);

            $(table).find('tr').first().find('td').attr({
                "role": "columnheader",
                "scope": "col"
            });
        });
    });

    $('.product-slider-wrapper').each((i, slider) => {
        const prev = $(slider).find('.slick-prev');
        const next = $(slider).find('.slick-next');

        function announceSlideChange() {
            $(slider).find('.product-slider .slick-slide:not(.slick-cloned)').each((i, slide) => {
                if (slide.classList.contains('slick-current')) {
                    const slideIndex = $(slide).data('slick-index');
                    const slideCount = $(slider).find('.product-slider .slick-slide:not(.slick-cloned)').length;
                    const slideText = `Slide ${slideIndex + 1} of ${slideCount}`;

                    announceToScreenReader(slideText);
                    console.log(slideText);
                }
            });
        }

        // prev.on('click', () => {
        //     setTimeout(announceSlideChange, 1000);
        // });

        // next.on('click', () => {
        //     setTimeout(announceSlideChange, 1000);
        // });
    });

    function handleRebuyCart() {
        $('.rebuy-cart').each((i, cart) => {
            setTimeout(() => {
                $(cart).find('.rebuy-product-grid').removeAttr('role').removeAttr('tabindex');
                $(cart).find('.primary-title').attr({
                    'role': 'heading',
                    'aria-level': 2
                });
            }, 1000);

            function handleChange() {
                $(cart).find('.rebuy-cart__flyout-empty-cart').each((i, empty) => {
                    $(empty).find('h4').attr({
                        'role': 'heading',
                        'aria-level': 2
                    });
                });
            };

            handleChange();

            $(cart).find('.rebuy-cart__flyout-content').each((i, content) => {
                const observer = new MutationObserver((mutations) => {
                    handleChange();
                });

                observer.observe(content, {
                    childList: true,
                });
            });

            function handleCartItems() {
                $(cart).find('.rebuy-cart__flyout-item').each((i, item) => {
                    $(item).find('.rebuy-cart__flyout-item-media > a').removeAttr('tabindex');
                    $(item).find('a.rebuy-cart__flyout-item-product-title').removeAttr('role').removeAttr('aria-level');

                    $(item).find('.rebuy-cart__flyout-item-quantity-widget').each((i, widget) => {
                        $(widget).find('.rebuy-cart__flyout-item-quantity-widget-button').each((i, button) => {
                            $(button).on('click', () => {
                                setTimeout(() => {
                                    announceToScreenReader('Loading...', 'alert');
                                }, 100);

                                setTimeout(() => {
                                    announceToScreenReader(`${$(widget).find('.rebuy-cart__flyout-item-quantity-widget-label').text()}`);
                                }, 1000);
                            });
                        })
                    });

                    $(item).find('.rebuy-money span[tabindex]').removeAttr('tabindex');
                });

                $(cart).find('.rebuy-cart__flyout-recommendations').each((i, recommendations) => {
                    $(recommendations).find('.rebuy-product-grid').removeAttr('role').removeAttr('tabindex');

                    $(recommendations).find('.splide__list').each((i, list) => {
                        const observer = new MutationObserver((mutations) => {
                            console.log(mutations);
                        });

                        observer.observe(list, {
                            childList: true,
                        });
                    });

                    setTimeout(() => {
                        $(recommendations).find('.rebuy-product-block').each((i, block) => {
                            $(block).find('.rebuy-button').each((i, button) => {
                                $(button).on('click', () => {
                                    setTimeout(() => {
                                        announceToScreenReader('Loading...', 'alert');
                                    }, 100);
                                });
                            });

                            $(block).find('.rebuy-product-title').removeAttr('role').removeAttr('aria-level');
                            $(block).find('.rebuy-money span[tabindex]').removeAttr('tabindex');
                        });
                    }, 1000);
                });
            }

            handleCartItems();

            $(cart).find('.rebuy-cart__flyout-items').each((i, items) => {
                $(items).removeAttr('role').removeAttr('tabindex');

                const observer = new MutationObserver((mutations) => {
                    handleCartItems();
                });

                observer.observe(items, {
                    childList: true,
                });
            });
        });
    }

    function handleRebuyModal() {
        $('#rebuy-modal').each((i, modal) => {
            $(modal).find('.rebuy-notification-dialog-header').attr({
                'tabindex': -1,
                'role': 'heading',
                'aria-level': 2
            }).focus();
        });
    }

    $('body').each((i, body) => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.classList.contains('rebuy-cart')) {
                        handleRebuyCart();
                    };

                    if ($(node).attr('id') === 'rebuy-modal') {
                        handleRebuyModal();
                    }
                });
            });
        });

        observer.observe(body, {
            childList: true,
        });
    });

    $('.cart__contents').each((i, cart) => {
        function handleChange() {
            $(cart).find('.cart-item').each((i, item) => {
                const name = $(item).find('.cart-item__name');
                const quantity = $(item).find('.cart-item__quantity');
                const input = quantity.find('.quantity__input');
                const minus = quantity.find('.quantity__button[name="minus"]');
                const plus = quantity.find('.quantity__button[name="plus"]');
                const remove = quantity.find('cart-remove-button > a.button');

                input.attr({
                    'aria-label': `Quantity for ${name.text().trim()}`,
                });

                minus.attr({
                    'aria-label': `Decrease quantity for ${name.text().trim()}`,
                });

                plus.attr({
                    'aria-label': `Increase quantity for ${name.text().trim()}`,
                });

                remove.attr({
                    'aria-label': `Remove ${name.text().trim()}`,
                });

                $(quantity).find('.quantity__button').each((i, button) => {
                    $(button).on('click', () => {
                        announceToScreenReader(`Loading...`, 'alert');

                        setTimeout(() => {
                            announceToScreenReader(`Quantity set to ${input.val()}`, 'alert');
                        }, 1000);
                    });
                });

                remove.on('click', () => {
                    announceToScreenReader(`Loading...`, 'alert');
                });

                function handleChange() {
                    const value = parseInt(input.val());

                    if (value <= 1) {
                        $(quantity).find('.quantity__button').first().attr({
                            'disabled': 'disabled',
                        })
                    } else {
                        $(quantity).find('.quantity__button').first().removeAttr('disabled');
                    }
                };

                handleChange();

                input.on('change', () => {
                    handleChange();
                });
            });
        }

        handleChange();

        $(cart).find('.js-contents').each((i, contents) => {
            const observer = new MutationObserver((mutations) => {
                handleChange();
            });

            observer.observe(contents, {
                childList: true,
            });
        });
    });

    $('#customer_login, #recover_email, #create_customer, form[action="/account/recover"], .contact-form').each((i, form) => {
        $(form).prepend($("<p class='required-indication'>Fields marked with an asterisk (*) are required.</p>"));

        const errors = $(form).find(".errors > ul");
        const requiredFields = $(form).find('input[name="customer[email]"], input[name="customer[password]"], input[name="email"]');

        if (errors.length > 0) {
            errors.attr({
                role: "alert",
            });
        }

        $(form).find('input[aria-describedby], select[aria-describedby], textarea[aria-describedby]').first().focus();
        $(form).find('[name="customer[first_name]"]').attr('autocomplete', 'given-name');
        $(form).find('[name="customer[last_name]"]').attr('autocomplete', 'family-name');
        $(form).find('[name="contact[name]"]').attr('autocomplete', 'name');
        $(form).find('[type="email"]').attr('autocomplete', 'email');

        requiredFields.each((i, requiredField) => {
            const label = $(form).find(`label[for="${requiredField.getAttribute('id')}"]`);

            console.log(requiredField);

            $(requiredField).attr({
                'required': "true",
            });

            $(requiredField).on('invalid', () => {
                requiredField.setCustomValidity(`${label.text().trim()} is required`);
            });

            $(requiredField).on("input", (event) => {
                requiredField.setCustomValidity("");
            });

            label.append(' *')
        });
    });

    $('menu-drawer').each((i, drawer) => {
        const dialog = drawer.querySelector('.mobile-facets__disclosure');

        const observer = new MutationObserver((mutations) => {
            if (dialog.hasAttribute('open')) {
                $(drawer).parents().siblings().not('.sr-only').attr("aria-hidden", true);

                setTimeout(() => {
                    $(drawer).find('.mobile-facets__close').focus();
                    trapFocus(dialog, focusableSelector);

                }, 500);
            } else {
                $(drawer).parents().siblings().removeAttr("aria-hidden");
            };
        });

        observer.observe(dialog, {
            attributes: true,
            attributeFilter: ['open'],
        });
    });

    $('.product').each((i, product) => {
        $(product).find('quantity-input').each((i, quantity) => {
            const input = $(quantity).find('.quantity__input');

            $(quantity).find('.quantity__button').each((i, button) => {
                $(button).on('click', () => {
                    setTimeout(() => {
                        announceToScreenReader(`Quantity set to ${input.val()}`, 'alert');
                    }, 1000);
                });
            });

            function handleChange() {
                const value = parseInt(input.val());

                if (value <= 1) {
                    $(quantity).find('.quantity__button').first().attr({
                        'disabled': 'disabled',
                    })
                } else {
                    $(quantity).find('.quantity__button').first().removeAttr('disabled');
                }
            };

            handleChange();

            input.on('change', () => {
                handleChange();
            });
        });

        console.log(product);

        findElementWithinTime('.gsinventory', 1000).then((gsinventory) => {
            $(gsinventory).parent().each((i, parent) => {
                const observer = new MutationObserver((mutations) => {
                    setTimeout(() => {
                        announceToScreenReader(`${$(parent).find('.gsinventory').text().trim()}`, 'alert');
                    }, 500);
                });

                observer.observe(parent, {
                    childList: true,
                });
            });
        });

        $(product).find('.gsinventory').each((i, gsinventory) => {
            $(gsinventory).parent().each((i, parent) => {
                const observer = new MutationObserver((mutations) => {
                    console.log(gsinventory.textContent.trim());
                    announceToScreenReader(`${gsinventory.textContent.trim()}`, 'alert');
                });

                observer.observe(parent, {
                    childList: true,
                });
            });
        });
    });

    $('sticky-header').each((i, drawer) => {
        const headerDrawer = drawer.querySelector('header-drawer');
        const details = drawer.querySelector('details');
        const menuButton = drawer.querySelector('.header__icon--menu');
        const goToMenu = $(`<button class="sr-only"><span>Go to menu</span></button>`);

        $(menuButton).attr({
            'tabindex': '0',
            'role': 'button',
        });

        $(menuButton).on('click', () => {
            $(menuButton).blur();

            setTimeout(() => {
                $(menuButton).focus();
            }, 500);
        });

        $(details).append(goToMenu);

        goToMenu.on('focus', () => {
            menuButton.focus();
        });

        $(drawer).find('nav.header__inline-menu').attr({
            'role': 'navigation',
            'aria-label': 'Primary',
        });


        $(drawer).find('.header__icon').each((i, icon) => {
            $(icon).on('click', () => {
                icon.blur();

                setTimeout(() => {
                    icon.focus();
                }, 500);
            });
        });

        const observer = new MutationObserver((mutations) => {
            if (details.hasAttribute('open')) {
                $(details).parents().siblings().not('.sr-only').attr("aria-hidden", true);

                setTimeout(() => {
                    console.log($(details).find(focusableSelector).last());
                    trapFocus(details, focusableSelector);
                }, 500);
            } else {
                $(details).parents().siblings().removeAttr("aria-hidden");
            };
        });

        observer.observe(details, {
            attributes: true,
            attributeFilter: ['open'],
        });
    });

$('.mobile-facets').each((i, facets) => {
        $(facets).find('.mobile-facets__details').each((i, details) => {
            const observer = new MutationObserver((mutations) => {
                if (details.hasAttribute('open')) {
                    trapFocus(details, focusableSelector);
                    $(facets).parents().siblings().not('.sr-only').attr("aria-hidden", true);
                } else {
                    $(facets).parents().siblings().removeAttr("aria-hidden");
                }
            });

            observer.observe(details, {
                attributes: true,
                attributeFilter: ['open'],
            });
        });
    });

    $('.collection-filters').each((i, filters) => {
        const activeFacets = filters.querySelector('.active-facets');

        function handleActiveFacets() {
            $(activeFacets).find('.active-facets__button').each((i, button) => {
                $(button).attr({
                    'tabindex': '0',
                    'role': 'button',
                    'aria-label': function () {
                        return `Remove ${$(this).text().trim()} from filter`;
                    },
                });
            });
        }

        handleActiveFacets();

        const observer = new MutationObserver((mutations) => {
            handleActiveFacets();
        });

        observer.observe(activeFacets, {
            childList: true,
        });
    });

    $('.collection-filters-cd').each((i, filters) => {
        const links = $(filters).find('.filter-by-menu > a');

        $(filters).find('.filter-by-menu').attr({
            'aria-label': 'Filter by',
        });

        links.wrapAll('<ul class="filter-by-menu__list"></ul>');

        links.each((i, link) => {
            $(link).wrap('<li class="filter-by-menu__item"></li>');
        });
    });

    $('footer').each((i, footer) => {
        const isTablet = window.matchMedia('(max-width: 990px)').matches;

        if(isTablet) {
            $(footer).find('.footer__content-bottom-wrapper').each((i, wrapper) => {
                $(wrapper).find('.footer__column--social').prependTo(wrapper);
            });
        };
    });

    console.log("Ready 1");
});

$(window).on("load", function () {
    $('img[src*="M_measurement_57_copy"]').attr('alt', 'A diagram of a male body showing instructions to measure the true waist size by considering the narrowest part of the torso that is just under the ribs. The hip measurements are also shown as the widest part of the haps/butt');
    $('img[src*="W_measurement_60"]').attr('alt', 'A diagram of a female body showing instructions for measuring bike pant sizing by considering the narrowest part of the torso, just under the ribs. The hip measurements are also indicated as the widest part of the hips/butt');
    $('img[src*="3I1A9235_"]').attr('alt', 'Man Repairing a dirt bike wearing a Denim Coverall for 1st image.');
    $('img[src*="Overall-2_"]').attr('alt', 'Man in Denim Coverall lying down on a gravel path reparing his mountain bike for 2nd image.');
    $('img[src*="3I1A0428big_"]').attr('alt', 'Woman in a Denim Coverall putting a spanner in her pocket for 3rd image.');
    $('img[src*="AI8I0831_"]').attr('alt', 'Man in a Denim Coverall sitting on a chair inside an apartment for 4th image.');
    $('img[src*="3I1A0068_"]').attr('alt', 'A smiling girl in a Denim Coverall and an orange cap reparing the car with a toolkit by her side for 5th image.');
    $('img[src*="MENS_2048x2048.png"]').attr('alt', "A diagram of a male body showing instructions to measure the true body measurement for men's jorts by considering the narrowest part of the torso that is just under the ribs. The hip measurements are also shown as the widest part of the haps/butt");

    $('.form__message').each((i, message) => {
        $(message).attr({
            'tabindex': '-1',
            'role': 'presentation',
        }).focus();
    });

    console.log("Load 1");
});

function isMobile() {
    const _media = window.matchMedia("(max-width: 767px)");

    return _media.matches;
}

function isDesktop() {
    const _media = window.matchMedia("(min-width: 1200px)");

    return _media.matches;
}

function randomId(length = 10) {
    const possibleCharacters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const possibleCharacterArray = Array.from(possibleCharacters);
    const resultArray = [];

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * possibleCharacterArray.length);
        const randomCharacter = possibleCharacterArray[randomIndex];
        resultArray.push(randomCharacter);
    }

    return resultArray.join('');
}

let liveElementTimeout = null;

function announceToScreenReader(text, role = "status", timeout = 1000, once = false) {
    const liveElement = document.querySelector(".live-status-region");

    if (!liveElement) {
        return;
    }

    liveElement.setAttribute("role", role);

    const paraElement = document.createElement("p");
    paraElement.textContent = text;
    liveElement.appendChild(paraElement);

    if (once && liveElementTimeout) {
        clearTimeout(liveElementTimeout);
    }

    liveElementTimeout = setTimeout(() => {
        liveElement.innerHTML = "";
        liveElement.setAttribute("role", "status");
        liveElementTimeout = null;
    }, timeout);
}

function trapFocus(element, focusableSelector = "input, button, a") {
    if (!element || typeof element !== "object") {
        console.error("Invalid element provided.");
        return;
    }

    if (typeof focusableSelector !== 'string') {
        return;
    }

    const focusableElements = Array.from(element.querySelectorAll(focusableSelector));

    if (focusableElements.length === 0) {
        console.warn("No focusable elements found within the provided element.");
        return;
    }

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    firstFocusable.addEventListener("keydown", (e) => {
        if (e.key === "Tab" && e.shiftKey) {
            e.preventDefault();
            lastFocusable.focus();
        }
    });

    lastFocusable.addEventListener("keydown", (e) => {
        if (e.key === "Tab" && !e.shiftKey) {
            e.preventDefault();
            firstFocusable.focus();
        }
    });

    // Focus the first focusable element initially.
    firstFocusable.focus();
}

function triggerSelfClick(e) {
    if (e.key === "Enter") {
        e.preventDefault();
        e.target.click();
    }
}

function insertHiddenClone(element) {
    const $ = jQuery;

    const $element = $(element);
    const headingClone = $(element).clone();
    headingClone.text($element.text().toLowerCase());
    headingClone.addClass("sr-only lowercase");

    $(headingClone).insertBefore(element);

    $element.attr({
        "aria-hidden": true,
    });
}

async function findElementWithinTime(selector, maxTimeInSeconds) {
    return new Promise(async (resolve, reject) => {
        let attempts = 0;
        const maxAttempts = maxTimeInSeconds;

        const interval = setInterval(async () => {
            attempts++;
            if (attempts >= maxAttempts) {
                clearInterval(interval);
                reject(new Error(`Element not found within ${maxTimeInSeconds} seconds.`));
            }

            const targetElement = document.querySelector(selector);
            if (targetElement) {
                clearInterval(interval);
                resolve(targetElement);
            }
        }, 1000);
    });
}

function triggerMouseEvent(element, eventType) {
    if (!element || ['mousedown', 'mouseup', 'click'].indexOf(eventType) === -1) {
        throw new Error('Invalid element or event type');
    }

    // Get the bounding rectangle of the element
    var rect = element.getBoundingClientRect();

    // Calculate the center coordinates
    var centerX = rect.left + rect.width / 2;
    var centerY = rect.top + rect.height / 2;

    // Create a new MouseEvent
    var event = new MouseEvent(eventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        clientX: centerX,
        clientY: centerY
    });

    // Dispatch the event
    element.dispatchEvent(event);
}

function queryAllShadowRoots(selector, root = document) {
    let elements = [];

    function queryShadowRoot(node) {
        if (node.shadowRoot) {
            elements.push(...node.shadowRoot.querySelectorAll(selector));
            node.shadowRoot.querySelectorAll('*').forEach(queryShadowRoot);
        }
    }

    // Initial query in the light DOM
    elements.push(...root.querySelectorAll(selector));

    // Query each shadow host for shadow DOM elements
    root.querySelectorAll('*').forEach(node => {
        queryShadowRoot(node);
    });

    return elements;
}

function isInViewport(element) {
    var bounding = element.getBoundingClientRect();
    var buffer = 200; // Relaxation buffer size

    return (
        bounding.left >= -buffer &&
        bounding.right <= (window.innerWidth + buffer || document.documentElement.clientWidth + buffer)
    );
}

function whenInView(element, callback, options = {}) {
    // Default options
    const defaultOptions = {
        root: null, // Use the viewport as the container
        rootMargin: '0px',
        threshold: 0.1 // Execute when 10% of the element is in view
    };

    // Merge default options with user-provided options
    const mergedOptions = { ...defaultOptions, ...options };

    // Ensure IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
        console.warn('IntersectionObserver is not supported in this browser.');
        return;
    }

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                callback(entry.target);
                // If you want the callback to only execute once, uncomment the next line
                // observer.unobserve(entry.target);
            }
        });
    }, mergedOptions);

    observer.observe(element);
}


function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
    };
}

document.addEventListener('keydown', function (event) {
    if (event.key === "Escape") {
        document.body.classList.add('disable-pointer-events');
    }
});

document.addEventListener('mousemove', function (event) {
    document.body.classList.remove('disable-pointer-events');
});
